import * as React from "react";
import { forwardRef } from "react";
const SvgAuditing = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 16 16", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "m15.704 12.273-3-3.016A1 1 0 0 0 12 8.962h-.812a5.989 5.989 0 1 0-5.187 3.016c1.054 0 2.09-.282 3-.816v.816c0 .267.104.522.292.711l3 3.016a.993.993 0 0 0 1.414 0l2-2.01a1.005 1.005 0 0 0-.003-1.422M5.997 9.968a4.021 4.021 0 1 1 4-4.022 4.01 4.01 0 0 1-4 4.022m7 3.605-2-2.01v-.59h.586l2 2.01z" }));
const ForwardRef = forwardRef(SvgAuditing);
export { ForwardRef as ReactComponent };
